// Lease pages are shared by the Customer and Partner dashboards; the base follows the URL prefix.
export const getLeasesHome = (pathname = "") =>
  pathname.startsWith("/partner") ? "/partner/leases" : "/customer/leases";
